import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { VariedadService } from "../service/variedad.service";
import { EspecieService } from "../../especie/service/especie.service";
import { UserService } from "../../user/service/user.service";

export interface Category {
  description: string;
  descriptor_category_id: number;
  value: string;
}
export interface Descriptor {
  descriptor_id: number;
  descriptor_label: string;
  descriptor_name: string;
  descriptor_categories: Category[];
  descriptor_type: string;
  descriptor_value: string | null;
}
export interface Group {
  title: string,
  descriptor_list: Descriptor[],
}
export interface Img {
  file_name: string,
  tag: string,
}

export interface DescriptorAdd {
  descriptor_category_id: number | null,
  descriptor_id: number,
  string_value: string,
}

@Component({
  selector: "app-variedad-edit",
  templateUrl: "./variedad-edit.component.html",
  styleUrls: ["./variedad-edit.component.css"],
})
export class VariedadEditComponent implements OnInit {
  constructor(
    private varietyService: VariedadService,
    private especieService: EspecieService,
    private userService: UserService,
    private route: ActivatedRoute
  ) { }

  varietyEditObs$!: Observable<any>;
  speciesObs$!: Observable<any>;
  varietalGroupObs$!: Observable<any>;
  userObs$!: Observable<any>;
  descriptorObs!: Observable<any>;
  urlBase = 'https://varscout.org/api/v1/files/public/?name=';

  variety_form = {
    is_avalible: false,
    variety_id: null,
    species_id: null,
    variety_name: null,
    common_name: null,
    synonyms: null,
    meaning: null,
    description: null,
    description_quechua: null,
    varietal_group: null,
    is_original: 'true',
    status: null,
    country: null,
    amd1_region: null,
    amd2_province: null,
    amd3_district: null,
    amd4_locality: null,
    institution_id: null,
    descriptors: [],
    pictures: [],
    comment: null
  };

  last_group_name!: string;
  descriptor_list_temp!: Descriptor[];
  group_list!: Group[];

  descriptor_list_added: DescriptorAdd[] = [];

  ngOnInit(): void {

    this.varietalGroupObs$ = this.varietyService.getVarietalGroups();
    this.speciesObs$ = this.especieService.getAll();
    this.userObs$ = this.userService.getUsers();

    const _id = this.route.snapshot.paramMap.get("id");
    if (_id) {
      this.loadVarietyForm(_id);
    } else {
      this.getDescriptorList(null);
      this.variety_form.is_avalible = true;
    }



  }

  loadVarietyForm(variety_id: number | string) {
    this.varietyEditObs$ = this.varietyService.getToEditVariety(variety_id);
    this.varietyEditObs$.subscribe(
      (_varietyObj: any) => {

        const _pictures = _varietyObj.data.images.map(
          (_img: any) => {
            return {
              'file_name': _img.image_name,
              'image_url': _img.image_url,
              'tag': _img.category.substring(0, 2).toUpperCase()
            }
          }
        );

        const _descriptors = _varietyObj.data.descriptors.map(
          (_des: any) => {
            return {
              'descriptor_category_id': _des.descriptor_category_id,
              'descriptor_id': _des.descriptor_id,
              'string_value': _des.string_value
            }
          }
        );

        this.getDescriptorList(_descriptors);

        const _variety_form = {
          is_avalible: true,
          variety_id: _varietyObj.data.variety_id,
          species_id: _varietyObj.data.species.species_id,
          variety_name: _varietyObj.data.variety_name,
          common_name: _varietyObj.data.common_name,
          synonyms: _varietyObj.data.synonyms,
          meaning: _varietyObj.data.meaning,
          description: _varietyObj.data.description,
          description_quechua: _varietyObj.data.description_quechua,
          varietal_group: _varietyObj.data.varietal_group,
          is_original: _varietyObj.data.is_original,
          status: _varietyObj.data.status,
          country: null,
          amd1_region: null,
          amd2_province: null,
          amd3_district: null,
          amd4_locality: null,
          institution_id: _varietyObj.data.user.user_id,
          descriptors: _descriptors,
          pictures: _pictures,
          comment: null
        };

        this.variety_form = _variety_form;
      }
    );
  }

  getDescriptorList(_descriptors: any[] | null) {
    const is_shared = null;
    this.descriptorObs = this.varietyService.getDescriptor(is_shared);
    this.group_list = [];
    this.descriptorObs.subscribe(
      (resp: any) => {
        resp.data.sort((a: any, b: any) => a.group_name.localeCompare(b.group_name));
        if (_descriptors) {
          resp.data.map(
            (resp_data: any) => {
              let _descriptor_value: any;
              if (resp_data.data_type == 'text') {
                if (resp_data.categories) {
                  const _descriptor_category_id = _descriptors.find(
                    _des_cat => _des_cat.descriptor_id == resp_data.descriptor_id
                  ).descriptor_category_id;
                  _descriptor_value = resp_data.categories.find(
                    (_des: any) => _des.descriptor_category_id == _descriptor_category_id
                  );
                } else {
                  _descriptor_value = _descriptors.find(
                    _des => _des.descriptor_id == resp_data.descriptor_id
                  ).string_value;
                }

              } else {
                _descriptor_value = _descriptors.find(
                  _des => _des.descriptor_id == resp_data.descriptor_id
                ).string_value;
              }
              const _descriptor_temp = {
                descriptor_id: resp_data.descriptor_id,
                descriptor_label: resp_data.descriptor_name,
                descriptor_name: 'desc_' + resp_data.descriptor_id,
                descriptor_categories: resp_data.categories,
                descriptor_type: resp_data.data_type,
                descriptor_value: _descriptor_value
              };
              if (resp_data.group_name == this.last_group_name) {
                this.descriptor_list_temp.push(_descriptor_temp);
              } else {
                if (this.descriptor_list_temp) {
                  const _group_temp = {
                    title: this.last_group_name,
                    descriptor_list: this.descriptor_list_temp,
                  }
                  this.group_list.push(_group_temp);
                }
                this.descriptor_list_temp = [];
                this.descriptor_list_temp.push(_descriptor_temp);
              }
              this.last_group_name = resp_data.group_name;
            }
          );
        } else {
          resp.data.map(
            (resp_data: any) => {
              const _descriptor_temp = {
                descriptor_id: resp_data.descriptor_id,
                descriptor_label: resp_data.descriptor_name,
                descriptor_name: 'desc_' + resp_data.descriptor_id,
                descriptor_categories: resp_data.categories,
                descriptor_type: resp_data.data_type,
                descriptor_value: null
              };
              if (resp_data.group_name == this.last_group_name) {
                this.descriptor_list_temp.push(_descriptor_temp);
              } else {
                if (this.descriptor_list_temp) {
                  const _group_temp = {
                    title: this.last_group_name,
                    descriptor_list: this.descriptor_list_temp,
                  }
                  this.group_list.push(_group_temp);
                }
                this.descriptor_list_temp = [];
                this.descriptor_list_temp.push(_descriptor_temp);
              }
              this.last_group_name = resp_data.group_name;
            }
          );
        }
      }
    );
  }

  save() {
    const tagDictionary = [
      { ind: 'TU', value: 'tuber' },
      { ind: 'PL', value: 'plant' },
      { ind: 'FL', value: 'flower' },
      { ind: 'LE', value: 'leaf' },
      { ind: 'FR', value: 'fruit' },
      { ind: 'SP', value: 'sprout' },
      { ind: 'SE', value: 'seed' },
      { ind: "ST", value: 'stem' },
      { ind: 'OT', value: 'other' },
    ];

    const _images: { image_name: string; image_url: string; category: string; }[] = [];

    this.variety_form.pictures.map(
      (_img: Img) => {
        const _category = tagDictionary.filter(row => row.ind === _img.tag)[0].value;
        _images.push({
          "image_name": _img.file_name,
          "image_url": this.urlBase + _img.file_name,
          "category": _category
        });
      }
    );

    const _variety_form = {
      variety_id: this.variety_form.variety_id,
      species_id: this.variety_form.species_id,
      variety_name: this.variety_form.variety_name,
      common_name: this.variety_form.common_name,
      synonyms: this.variety_form.synonyms,
      meaning: this.variety_form.meaning,
      description: this.variety_form.description,
      description_quechua: this.variety_form.description_quechua,
      varietal_group: this.variety_form.varietal_group,
      is_original: 'true',
      status: this.variety_form.status,
      country: this.variety_form.country,
      amd1_region: this.variety_form.amd1_region,
      amd2_province: this.variety_form.amd2_province,
      amd3_district: this.variety_form.amd3_district,
      amd4_locality: this.variety_form.amd4_locality,
      institution_id: this.variety_form.institution_id,
      descriptors: this.descriptor_list_added,
      images: _images,
      comment: this.variety_form.comment
    };

  }

  addDescriptor(descriptor: any, $event: any) {
    if (descriptor.descriptor_type == "text") {
      if (descriptor.descriptor_categories) {
        const _descriptor = {
          descriptor_category_id: $event.value.descriptor_category_id,
          descriptor_id: descriptor.descriptor_id,
          string_value: $event.value.description,
        }
        this.createOrEditDescriptor(_descriptor);
      } else {
        const _descriptor = {
          descriptor_category_id: null,
          descriptor_id: descriptor.descriptor_id,
          string_value: $event.target.value,
        }
        this.createOrEditDescriptor(_descriptor);
      }
    } else if (descriptor.descriptor_type == "numeric") {
      const _descriptor = {
        descriptor_category_id: null,
        descriptor_id: descriptor.descriptor_id,
        string_value: $event.target.value,
      }
      this.createOrEditDescriptor(_descriptor);
    }
  }

  private createOrEditDescriptor(_descriptor: DescriptorAdd) {
    const index = this.descriptor_list_added.findIndex(_descriptor_added => _descriptor_added.descriptor_id == _descriptor.descriptor_id);
    if (index > -1) {
      this.descriptor_list_added.splice(index, 1);
    }
    this.descriptor_list_added.push(_descriptor);
  }
}
